import { Button, Card, Form, Input } from 'antd';
import { useForm } from 'antd/es/form/Form';
import React from 'react';

import dataToCopyTextMapper from './helpers/dataToCopyTextMapper';

import useEnginesEmailQuery from 'api/hooks/Engines/useEnginesEmailQuery';
import CopyButton from 'components/CopyButton/CopyButton';
import Loading from 'components/Loading/Loading';

type RequestForm = { domain: string };

const Email = () => {
	const { data, isLoading, isFetched, isHasErrors, fetch } = useEnginesEmailQuery();

	const [form] = useForm<RequestForm>();

	const onSubmit = () => {
		fetch(form.getFieldValue('domain'));
	};

	return (
		<>
			<Card title="Введите домен">
				<Form form={form} layout="vertical" onFinish={onSubmit}>
					<Form.Item name="domain">
						<Input />
					</Form.Item>

					<Button type="primary" htmlType="submit" loading={isLoading}>
						Запросить
					</Button>
				</Form>
			</Card>

			<br />

			{isFetched && !isHasErrors && (
				<Loading isEnable={isLoading}>
					<Card title="Почта движка" extra={<CopyButton text={dataToCopyTextMapper(data)} />}>
						{data}
					</Card>
				</Loading>
			)}
		</>
	);
};

export default Email;
